import { ChangeEvent, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { MiBuildHouseAlt } from "@miplatform/assets";
import { MiIcon, MiIconButton, MiPlaceholderArea, MiSearchInput } from "@miplatform/components";
import { TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { mdiPrinterOutline } from "@mdi/js";
import { Box, Typography } from "@mui/material";
import { ConfigAccordionHeader } from "../../../../../Config/components/ConfigAccordionHeader/ConfigAccordionHeader";

export function CustomerItemsPricingTab() {
  const [search, setSearch] = useState("");
  const searchPlaceholder = "Search...";
  const { classes, theme } = useStyles();

  return (
    <ConfigAccordionHeader
      title="Items Pricing"
      disableCollapse
      customAction={
        <Box>
          <MiSearchInput
            className={classes.searchContainer}
            value={search}
            handleChange={(e: ChangeEvent<HTMLInputElement>) =>
              setSearch(e.target.value)
            }
            placeholder={searchPlaceholder}
          />
          <MiIconButton
            data-testid="mi-orders-print-icon-button"
          >
            <MiIcon
              path={mdiPrinterOutline}
              color={theme.palette.common.white}
            />
          </MiIconButton>
        </Box>
      }
    >
      <Box display="flex" flexDirection="column" gap={2}>
        <Typography
          variant={TYPOGRAPHY_VARIANTS.BODY2}
          color={theme.palette.text.secondary}
        >
          Set a Multiplier or Markup, then enter a Net Sale Price or adjust the Margin per item.
        </Typography>
        <MiPlaceholderArea
          text="No Items or Categories Items Created"
          helperText="Tip: To set pricing for items, setup the categories first."
          iconComponent={<img src={MiBuildHouseAlt} alt="House Icon" />}
          containerStyle={{
            backgroundColor: theme.palette.primary.light,
            height: "100%",
            minHeight: 450,
          }}
        />
      </Box>
    </ConfigAccordionHeader>
  );
}

const useStyles = makeStyles()((theme) => ({
  searchContainer: {
    width: 268,
    marginTop: 3,
    backgroundColor: "transparent !important",
    minHeight: "100%",
    '& .MuiInputBase-root': {
      backgroundColor: "white"
    }
  }
}));
